import { PropsWithChildren } from 'react';

import { ChevronRightIcon, Text } from '@thefarmersfront/kitchen';

import styles from './DeliveryTypeSection.module.scss';

interface DeliveryTypeSectionProps {
  title: string;
  onClickNavigate?: () => void;
}

const DeliveryTypeSection = ({ title, children, onClickNavigate }: PropsWithChildren<DeliveryTypeSectionProps>) => {
  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <Text size="xxlarge" weight="semi-bold">
          {title}
        </Text>
        <ChevronRightIcon
          size={16}
          onClick={onClickNavigate}
          style={{ cursor: onClickNavigate ? 'pointer' : undefined }}
        />
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export { DeliveryTypeSection };
